import React from 'react';
import { motion } from 'framer-motion';
import { QRCodeSVG } from 'qrcode.react';
import '../assets/styles/Contact.css';
import logo from '../assets/images/logo_qr.svg';

const Contact = () => {
  return (
    <section id="contact" className="contact">
      <div className="container">
        <motion.div
          className="contact-inner"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <h2>Contact Us</h2>
          <p className="contact-sub">Scan the QR code to get in touch, or email us directly.</p>

          <div className="qr-wrapper">
            <QRCodeSVG
              value="mailto:info@fertro.com"
              size={220}
              level="H"
              imageSettings={{
                src: logo,
                width: 56,
                height: 56,
                excavate: true,
              }}
            />

          </div>

          <a href="mailto:info@fertro.com" className="contact-email">
            info@fertro.com
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
